import React, { Component } from "react";

import { CButton, CCard, CCardBody, CTooltip } from "@coreui/react";
import {
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineWarning
} from "react-icons/ai";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Input,
  FormGroup,
  FormText,
  Label,
  Modal,
  ModalBody,
  ModalHeader
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import imgImport from "../../../assets/imgs/import/import_icon.png";
import NoData from "../../../assets/imgs/no_data.svg";
import Breadcrumb from "../../../components/Breadcrumb";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

import "./style.css";

class Import extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      sent: [],
      group: this.props.general.active_roles.group_id,
      processing: null,
      file: null,
      dragging: false,
      error: "",
      showModal: false,
      getError: false,
      dataError: [],
      onSending: false,
      onProcessing: false,
      totalLineErrors: 0,
      totalLines: 0,
      nameSheet: ""
      // totalStudentsInSchool: 0,
      // totalStudentsImported: 0
    };

    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    // Verifica se o usuário é do grupo 45. Se for, não deixa acessar a página
    if (
      this.props.general.active_roles.group_id === 45 ||
      this.props.general.active_roles.group_id === 92
    ) {
      this.props.history.push("/home");
      return;
    }

    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.handleSentFiles();
    this.changeBackgroundColor();
  }

  handleDragOver = e => {
    e.preventDefault();
    this.setState({ dragging: true });
  };

  handleDragLeave = () => {
    this.setState({ dragging: false });
  };

  handleInputChange = e => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.name.endsWith(".xlsx")) {
      this.setState({ file: selectedFile, error: "" });
    } else {
      this.setState({
        error: "Arquivo incompatível. Por favor envie um arquivo do tipo xlsx."
      });
      toastr.error(
        "Arquivo incompatível",
        "Por favor envie um arquivo do tipo xlsx."
      );
    }
  };

  handleSentFiles() {
    this.setState({ loading: true });
    axios
      .get(`${URL.api}import/sent`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            sent: resp.data.data.sort(this.sortFiles),
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  onFilesAdded = () => {
    this.setState({ onSending: true });

    let files;
    if (this.state.file) {
      files = [this.state.file];
    } else {
      files = Array.from(this.fileInputRef.current.files).filter(file =>
        file.name.endsWith(".xlsx")
      );
    }
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append(`file${i}`, files[i]);
    }

    axios
      .post(`${URL.api}import/send`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.props.user.token}`
        }
      })
      .then(
        resp => {
          this.handleSentFiles();
          this.handleCancel();
          this.setState({ onSending: false });
        },
        error => {
          this.error(error.response.statusText);
          this.setState({ onSending: false });
        }
      );
  };

  handleDrop = e => {
    e.preventDefault();
    this.setState({ dragging: false });

    const droppedFile = e.dataTransfer.files[0];

    if (droppedFile && droppedFile.name.endsWith(".xlsx")) {
      this.setState({ file: droppedFile, error: "" });
      this.fileInputRef.current.files = e.dataTransfer.files;
    } else {
      this.setState({
        error: "Arquivo incompatível. Por favor envie um arquivo do tipo xlsx."
      });
      toastr.error(
        "Arquivo incompatível",
        "Por favor envie um arquivo do tipo xlsx."
      );
    }
  };

  removeSent = filename => {
    axios
      .post(
        `${URL.api}import/delete`,
        { name: filename },
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(
        resp => {
          this.handleSentFiles();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  };

  async processFiles() {
    if (!this.state.sent.length) {
      toastr.warning("Atenção", "Para continuar, importe alguma planilha");
      return;
    }

    this.setState({ onProcessing: true });

    for (const file of this.state.sent) {
      try {
        this.setState({ processing: file.original_name });

        await axios
          .post(
            `${URL.api}import/process/${file.original_name}`,
            { group_id: this.state.group },
            { headers: { Authorization: `Bearer ${this.props.user.token}` } }
          )
          .then(resp => {
            if (resp.data.errors.length) {
              this.setState({
                getError: true,
                dataError: resp.data.errors,
                totalLineErrors: resp.data.errors.length,
                totalLines: resp.data.totalLines,
                nameSheet: resp.data.filename
                // totalStudentsInSchool: resp.data.total_students,
                // totalStudentsImported: resp.data.successes.length
              });
            }
          });

        this.setState(state => {
          const sent = state.sent.filter(
            item => item.original_name !== file.original_name
          );

          this.setState({
            showModal: true,
            onProcessing: false
          });
          return { sent };
        });
      } catch (error) {
        // this.error(error.response.statusText);
        this.setState({ showModal: true, getError: true });
      }
    }

    this.setState({ processing: null });
    this.setState({ onProcessing: false });
  }

  handleDropzoneClick = () => {
    this.fileInputRef.current.click();
  };

  handleCancel = () => {
    this.setState({ file: null, error: "" });
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = "";
    }
  };

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  };

  handleDownload = () => {
    const link = document.createElement("a");
    const urlLink =
      "https://back.educandus.com.br/uploads/sheets/1724873099-importacao_alunos.xlsx";
    link.href = urlLink;
    link.download = "importacao_de_alunos_educandus.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  changeBackgroundColor = () => {
    const container = document.querySelector(".container-fluid");
    if (container) {
      container.style.backgroundColor = "#F0F4F8";
    }
  };

  render() {
    const { loading, sent, dragging, file, error, processing } = this.state;

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <div className="w-100 rounded">
          <CCard>
            {this.state.showModal && (
              <Modal
                isOpen={this.state.showModal}
                toggle={null}
                className={null}
                onOpened={() => {
                  if (!this.state.edit) {
                    this.componentDidMount();
                  }
                }}
                size="lg"
              >
                <ModalHeader style={{ border: "none" }}>
                  <div className="header-import">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        this.setState({
                          showModal: false,
                          getError: false,
                          dataError: []
                        });
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </ModalHeader>
                <ModalBody>
                  <div className="import-students-modal-body">
                    {!this.state.getError ? (
                      <>
                        <AiOutlineCheckCircle
                          style={{ fontSize: "100px", color: "#7ab213" }}
                        />
                        <span
                          style={{ fontSize: "25px", marginBottom: "10px" }}
                        >
                          Sucesso
                        </span>
                        <span>Importação processada com sucesso.</span>
                        <br></br>
                      </>
                    ) : (
                      <>
                        <AiOutlineWarning
                          style={{ fontSize: "100px", color: "#e2d80b" }}
                        />
                        <span
                          style={{ fontSize: "25px", marginBottom: "10px" }}
                        >
                          Diagnóstico da Importação
                        </span>
                        <p>
                          Ocorreram erros durante o processamento da importação.
                          Pedimos que verifiquem os dados e tentem novamente.
                          Caso o problema persista, abra um chamado para
                          assistência adicional.
                        </p>
                        <span>
                          Foram importados{" "}
                          <b>{this.state.totalStudentsImported}</b> estudantes.
                        </span>
                        <span>
                          O total de estudantes da sua escola é{" "}
                          <b>{this.state.totalStudentsInSchool}</b>.
                        </span>
                        <br></br>
                        <div className="d-flex justify-content-start flex-column align-items-start w-100">
                          <span>Nome do arquivo: {this.state.nameSheet}</span>
                          <span className="d-flex align-items-center mt-2">
                            <AiOutlineCloseCircle
                              style={{
                                fontSize: "18px",
                                color: "#d11b0a",
                                marginRight: "3px"
                              }}
                            />
                            <span>
                              Erro em <b>{this.state.totalLineErrors}</b> linhas
                              de <b>{this.state.totalLines}</b>
                            </span>
                          </span>
                        </div>

                        {this.state.dataError.length && (
                          <div className="import-students-container-table">
                            <table border="1" cellPadding="10">
                              <thead>
                                <tr>
                                  <th>Linha</th>
                                  <th>Matrícula</th>
                                  <th>Nome Completo</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.dataError.map((line, index) => (
                                  <tr key={line.numero_linha}>
                                    <td>{line.numero_linha}</td>
                                    <td>{line.matricula}</td>
                                    <td>{line.nome}</td>
                                    <td>{line.error}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </ModalBody>
              </Modal>
            )}

            <CCardBody className="import-body p-2.5 overflow-auto">
              <section>
                <h5>Como importar seus estudantes</h5>
                <hr />
                <p>
                  A importação de estudantes possui três etapas: primeiro, você
                  baixa a planilha modelo e insere os dados dos seus estudantes;
                  segundo, confere se os dados importados estão corretos e faz o
                  envio pela plataforma; por fim, você clica no botão de
                  processar.
                </p>
                <p>
                  Caso seja informado algum erro leia com atenção e faça o que é
                  instruído.
                </p>
              </section>
              <section>
                <h6>Faça download da planilha modelo</h6>
                <hr />
                <div className="d-flex flex-column flex-md-row">
                  <div className="d-flex flex-column col-12 col-md-3 justify-content-center align-items-center">
                    <img
                      src={imgImport}
                      style={{ width: "75%" }}
                      alt="import imagem"
                    ></img>
                    <CButton color="secondary" onClick={this.handleDownload}>
                      Fazer download
                    </CButton>
                  </div>

                  <div className="d-flex flex-column justify-content-center col-12 col-md-9">
                    <span className="mb-3">
                      Para importar seus estudantes a partir de uma planilha,
                      ela precisa estar{" "}
                      <b>no formato correto da planilha modelo</b> que
                      disponibilizamos.
                    </span>
                    <span className="mb-2">
                      Confira as <b>regras</b> abaixo e selecione a planilha:
                    </span>
                    <ul>
                      <li className="mb-1">
                        Formato permitido: <b>XLSX</b>
                      </li>
                      <li className="mb-1">
                        Tamanho máximo: <b>10 Mb</b>
                      </li>
                      <li className="mb-1">
                        Número de linhas ilimitado desde que não tenha uma{" "}
                        <b>linha em branco</b>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
              {!this.state.sent.length && (
                <section>
                  <div className="container mt-3">
                    <FormGroup>
                      <Label for="exampleFile">
                        Selecione a planilha para importar:
                      </Label>
                      <div
                        className={`dropzone ${dragging ? "dragging" : ""}`}
                        onDragOver={this.handleDragOver}
                        onDragLeave={this.handleDragLeave}
                        onDrop={this.handleDrop}
                        onClick={this.handleDropzoneClick}
                      >
                        <Input
                          id="exampleFile"
                          name="file"
                          type="file"
                          accept=".xlsx"
                          onChange={this.handleInputChange}
                          style={{ display: "none" }}
                          innerRef={this.fileInputRef}
                        />
                        <p>
                          {file
                            ? file.name
                            : "Arraste o arquivo .xlsx para cá ou clique para selecionar"}
                        </p>
                      </div>
                      {error && <p className="text-danger">{error}</p>}
                      {file && (
                        <div className="mt-3">
                          {!this.state.onSending ? (
                            <>
                              <CButton
                                color="primary"
                                onClick={e => this.onFilesAdded()}
                              >
                                Enviar
                              </CButton>{" "}
                              <CButton
                                color="secondary"
                                onClick={this.handleCancel}
                              >
                                Cancelar
                              </CButton>
                            </>
                          ) : (
                            <Loading />
                          )}
                        </div>
                      )}
                      <FormText>
                        Para importar uma nova planilha, primeiro conclua a
                        importação ou exclua a planilha atual.
                      </FormText>
                    </FormGroup>
                  </div>
                </section>
              )}

              <section>
                {this.state.sent.length ? (
                  <div className="w-100">
                    <div className="w-100">
                      <table className="table table-hover table-outline mb-0 d-none d-sm-table w-100 mb-4">
                        <thead className="thead-light">
                          <tr>
                            <th>Arquivo</th>
                            <th>Data de criação</th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.sent.map((item, index) => (
                            <tr key={index}>
                              <td>{item.name}</td>
                              <td>{item.created_at}</td>
                              <td>
                                <CTooltip content="Apagar">
                                  <CButton
                                    color="danger"
                                    onClick={() =>
                                      this.removeSent(item.original_name)
                                    }
                                  >
                                    <i className="fa fa-trash"></i>
                                  </CButton>
                                </CTooltip>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="mt-2 w-100 d-flex flex-column justify-content-center align-items-center">
                    <img
                      src={NoData}
                      style={{
                        height: "100px",
                        marginBottom: "1rem",
                        opacity: 0.5
                      }}
                      alt=""
                    />
                    <span>Nenhum arquivo a ser processado</span>
                  </div>
                )}
              </section>
              <section className="d-flex justify-content-end">
                {!this.state.onProcessing ? (
                  <CButton
                    color="primary"
                    onClick={() => this.processFiles()}
                    disabled={!this.state.sent.length}
                  >
                    Processar
                  </CButton>
                ) : (
                  <Loading />
                )}
              </section>
            </CCardBody>
          </CCard>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Import);
